import { FunctionComponent } from "react";
import s from "./Loaders.module.css";


interface LoaderDotSpinnerProps {
    
}
 
const LoaderDotSpinner: FunctionComponent<LoaderDotSpinnerProps> = () => {
    return ( 
    <div className={s.dotSpinner}>
        <div className={s.dotSpinnerDot} />
        <div className={s.dotSpinnerDot} />
        <div className={s.dotSpinnerDot} />
        <div className={s.dotSpinnerDot} />
        <div className={s.dotSpinnerDot} />
        <div className={s.dotSpinnerDot} />
        <div className={s.dotSpinnerDot} />
        <div className={s.dotSpinnerDot} />
    </div> );
}
 
export default LoaderDotSpinner;